import { ApiUtil as api } from "@/utils/api.util.js";

export class BatchService {
	static URL = process.env.API_URL + process.env.API_VER;
	static RESOURCE = "/batches/";

	static all(queryParams = {}) {
		return api.get(this.URL + this.RESOURCE, queryParams);
	}
	static find(id, queryParams = {}) {
		return api.get(this.URL + this.RESOURCE + id, queryParams);
	}
	static findByColumn(column, value, queryParams = {}) {
		return api.get(this.URL + this.RESOURCE + 'find-by-column/' + column + '/' + value, queryParams);
	}
	static search(keyword, queryParams = {}) {
		return api.get(this.URL + this.RESOURCE + 'search/' + keyword, queryParams);
	}
	static unbatch(id, queryParams = {}) {
		return api.post(this.URL + this.RESOURCE + 'unbatch/' + id, queryParams);
	}
	static save(queryParams = {}) {
		return api.post(this.URL + this.RESOURCE, queryParams);
	}
}



// WEBPACK FOOTER //
// ./src/services/batch.service.js